/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useEffect, useRef} from "react";
import loadable from "@loadable/component";

import styles from "./styles.css";
import PropTypes from "prop-types";
import MetaTagsCarListingV2 from "../../shared/meta-tags-car-listing-v2";
import { DEFAULT_CITY, LISTING_CONFIG, NUMBER, SALE_META_TYPE, SPECIALPAGETYPE } from "../../../constants/app-constants";
import ListingContactBottom from "../listing-contact-bottom";
import SearchMeta from "../../shared/meta-constants/search-meta";
import CarBuyingGuide from "../../shared/car-buying-guide";
import qs from "query-string";
import { useLocation } from "react-router-dom";
import ScrollToTop from "../../shared/scroll-to-top";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import SeoInterlinkingList from "../seo-interlinking-list/component";
import CarListRevamp from "../car-list-revamp";
import {  API_VERSION_V2 } from "../../../service/api-version";
import Filters from "../../../utils/filters-v2";
import useExperiments from "../../../hooks/use-statsig-experiment";
import { EXPERIMENT_NAME } from "../../../utils/statsig-ab-utils/constant";
import { GA_EVENTS } from "./tracking";
import PageLoader from "../../shared/page-loader";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import useOnloadIdle from "../../../hooks/use-onload-idle";
const CoachMark = loadable(() => import("../coach-mark/component"), { fallback: <PageLoader/> });
const NudgeCards = loadable(() => import("../nudge-cards"), { fallback: <PageLoader/> });
const SaleStripBar = loadable(() => import("../sale-strip-bar"), { fallback: <PageLoader /> });
const SellOutrightStripBar = loadable(() => import("../../shared/sell-outright-strip-bar"), { fallback: <PageLoader /> });

const CarListing = ({
    fetchFiltersConnect,
    updateSelectedOnScreenFilterConnect,
    updateAllFiltersVisibilityConnect,
    fetchCategoryFiltersConnect,
    categories,
    updateSortModalVisibilityConnect,
    metaContent,
    dynamicContent,
    selectedCity,
    location = {},
    match,
    fetchConfigConnect,
    saleConfig = {},
    showPreApprovalCoachmark,
    setPreApprovalCoachMarkDisplayConnect,
    isLoggedIn,
    content,
    allFilters = {},
    selectedFilters,
    appliedFilters,
    isUserZeroDpVariant,
    secureToken,
    getPreApprovalLoanDetailsConnect,
    urlOptions,
    fetchClpDataConnect,
    isCarListSSR,
    faqData,
    browseSeoLinks,
    webPriceDropDesktop,
    webLocationHighlighting
}) => {

    useExperiments({experimentKeys: [EXPERIMENT_NAME.web_price_drop_desktop]});

    const { name } = selectedCity || {};
    const query = (useLocation().search || "").toString();
    const queryParams = qs.parse(query);
    const appliedFilterRef = useRef();

    const { category } = queryParams;
    let { specialPageType } = metaContent || {};
    specialPageType = specialPageType || SPECIALPAGETYPE.COMMON;
    const {pathname = ""} = location || {};
    const { currentType} = saleConfig?.data || saleConfig || {};

    useEffect(() => {
        if (specialPageType === SPECIALPAGETYPE.LOCATION_BASED && name) {
            trackDesktopCustomEventsAU(trackDesktopCustomEventsAU.LISTING_PAGE, {
                eventAction: "location_page",
                eventLabel: name
            });
        }
    }, [name, specialPageType]);

    useEffect(() => {
        fetchFiltersConnect(API_VERSION_V2).then(() => {});
    }, [fetchFiltersConnect, secureToken]);

    useEffect(() => {
        const updateTracking = async () => {
            await yieldToMain();
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.ZERO_DP_CLP, {
                eventLabel: isUserZeroDpVariant ? "Landed_Variant B" : "Landed_Variant A"
            });
            const {data: webPriceDropVariant = ""} = webPriceDropDesktop || {};
            trackDesktopCustomEventsAU(GA_EVENTS.WEB_PRICE_DROP_DESKTOP, {
                ...GA_EVENTS.WEB_PRICE_DROP_DESKTOP,
                eventLabel: webPriceDropVariant
            });
        };
        updateTracking();
    }, [isUserZeroDpVariant, webPriceDropDesktop]);

    useEffect(() => {
        fetchConfigConnect();
    }, [fetchConfigConnect]);

    useEffect(() => {
        getPreApprovalLoanDetailsConnect({fetchListingDetails: true});
    }, [getPreApprovalLoanDetailsConnect]);

    useEffect(() => {
        if (category && !(categories || []).length) {
            fetchCategoryFiltersConnect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const closePopUp = (e) => {
        const isFilterClicked = !!e.target.closest(".filter-section");
        if (!isFilterClicked) {
            updateSelectedOnScreenFilterConnect("");
            updateAllFiltersVisibilityConnect(false);
            updateSortModalVisibilityConnect(false);
        }
    };

    useEffect(() => {
        const popUpClickListener = document.addEventListener("click", closePopUp);
        return () => {
            document.removeEventListener("click", popUpClickListener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (showPreApprovalCoachmark) {
            window.setTimeout(() =>
                setPreApprovalCoachMarkDisplayConnect(false),
            NUMBER.FIVE_THOUSAND
            );
        }

        const {data: highlightVariant} = webLocationHighlighting || {};
        trackDesktopCustomEventsAU(GA_EVENTS.LOCATION_HIGHLIGHING.eventAction, {
            ...GA_EVENTS.LOCATION_HIGHLIGHING,
            eventLabel: highlightVariant
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (appliedFilters.length && content.length && (appliedFilterRef.current !== appliedFilters.length)) {
            appliedFilterRef.current = appliedFilters.length;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appliedFilters.length, content.length]);

    useEffect(() => {
        if (!isCarListSSR) {
            const searchQuery = queryParams.search;
            const listingPath = pathname.slice(1);
            const filtes = new Filters({cityCode: selectedCity.code});
            const { payload } = filtes.getListingPayload({
                selectedFilters,
                filters: allFilters,
                options: {
                    ...urlOptions,
                    ...(
                        searchQuery && {
                            search: searchQuery
                        }
                    )
                }
            });
            fetchClpDataConnect({
                spath: listingPath
            }, payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appliedFilters.length]);
    const isIdleLoaded = useOnloadIdle();

    return (
        <React.Fragment>
            <MetaTagsCarListingV2
                cityName={selectedCity.name || DEFAULT_CITY.AU.city_name}
                metaContent={metaContent}
                dynamicContent={dynamicContent}
                location={location}
                match={match}
                countryCode="au"
                carListing={content}
                selectedFilters={selectedFilters}
                searchedFilter={(urlOptions || {}).search}
            />
            <SearchMeta location={location} />
            {isIdleLoaded && LISTING_CONFIG[specialPageType].IS_COACHMARK_ENABLED && <CoachMark showCoachMark={showPreApprovalCoachmark} />}
+           {isIdleLoaded && secureToken &&
                 <div styleName={"styles.nudgeCardContainer styles.nudgeCardContainerNew"}>
                     <NudgeCards />
                 </div>
            }
            <div>
                {isIdleLoaded && currentType && currentType !== "default" &&
                  <div
                      styleName={"styles.backgroundBlue"}>
                      <SaleStripBar metaType={SALE_META_TYPE.LISTING}/>
                  </div>
                }

                <CarListRevamp
                    selectedCity={selectedCity}
                    showFilterPageRevamp={true}
                    dynamicContent={dynamicContent}
                    selectedCategory={category}
                    categories={categories}
                />

                <SeoInterlinkingList
                    isRevampClp = {true}
                    faqData={faqData}
                    browseSeoLinks={browseSeoLinks}
                />
                { isIdleLoaded && <ListingContactBottom selectedCity={selectedCity} specialPageType={specialPageType} />}
                {dynamicContent && <CarBuyingGuide
                    dynamicContent={dynamicContent}
                    selectedCategory={category}
                    categories={categories}
                />}
            </div>
            {isIdleLoaded && isLoggedIn && <SellOutrightStripBar />}
            <ScrollToTop threshold={600} showIcon={true} />
        </React.Fragment>
    );
};

CarListing.propTypes = {
    fetchFiltersConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    updateAllFiltersVisibilityConnect: PropTypes.func,
    updateSortModalVisibilityConnect: PropTypes.func,
    fetchCategoryFiltersConnect: PropTypes.func,
    metaContent: PropTypes.object,
    dynamicContent: PropTypes.object,
    selectedCity: PropTypes.object,
    categories: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    secureToken: PropTypes.string,
    fetchConfigConnect: PropTypes.func,
    setPreApprovalCoachMarkDisplayConnect: PropTypes.func,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    showPreApprovalCoachmark: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    saleConfig: PropTypes.object,
    content: PropTypes.array,
    allFilters: PropTypes.object,
    selectedFilters: PropTypes.array,
    seoMenu: PropTypes.object,
    updateFilterOptionDataConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    appliedFilters: PropTypes.object,
    urlOptions: PropTypes.object,
    fetchClpDataConnect: PropTypes.func,
    isCarListSSR: PropTypes.bool,
    faqData: PropTypes.array,
    browseSeoLinks: PropTypes.array,
    gaId: PropTypes.string,
    showEmailSupportModal: PropTypes.bool,
    webPriceDropDesktop: PropTypes.object,
    webLocationHighlighting: PropTypes.object,
    rating: PropTypes.string,
    reviews: PropTypes.string
};

export default CarListing;
